"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAirdropClaimEvents = fetchAirdropClaimEvents;
const constants_js_1 = require("../../common/constants.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
async function fetchAirdropClaimEvents(params) {
    const eventType = constants_js_1.conf[constants_js_1.CONF_ENV].AIRDROP_CLAIM_EVENT_TYPE;
    const events = await (0, fetchEvents_js_1.fetchEvents)({
        startTime: params.startTime,
        endTime: params.endTime,
        eventTypes: [eventType],
        order: "descending",
    });
    const airdropClaimEvents = events.map((e) => {
        return e;
    });
    return airdropClaimEvents;
}
//# sourceMappingURL=fetchAirdropClaimEvent.js.map